import moment from 'moment';
import {DATETIME_FORMAT} from './date.model';

export class PlantRiskCountryModel {
  country: string;
  prcData: PlantRiskCountryDataModel[];
}

export class PlantRiskCountryDataModel {
  co2Fc: number;
  coalFc: number;
  gasFc: number;
  priceFc: number;
  ts: string;

  constructor(objIn: any) {
    this.co2Fc = objIn.co2_forecast || null;
    this.coalFc = objIn.coal_forecast || null;
    this.gasFc = objIn.gas_forecast || null;
    this.priceFc = objIn.price_forecast || null;
    this.ts = objIn.timestamp
      ? moment.utc(objIn.timestamp).local().format(DATETIME_FORMAT)
      : '';
  }
}
